import { YandexMethodNames, YandexCounters, RemontDevMetricCounterNumber } from './analytics.constants';
class Analytics {
    constructor(accounts) {
        this.accounts = accounts;
        this.callQueue = [];
        if (accounts.yandex.includes(RemontDevMetricCounterNumber)) {
            this.sendEvent(RemontDevMetricCounterNumber, 'init', {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
            });
        }
    }
    sendEvent(...args) {
        if ('ym' in window && window.ym != null && typeof window.ym === 'function') {
            const counterIds = this.accounts.yandex;
            if (this.callQueue.length !== 0) {
                this.callQueue.forEach((deferredCall) => {
                    counterIds.forEach((counterId) => {
                        Analytics.yandexCall(counterId, ...deferredCall.args);
                    });
                });
                this.callQueue = [];
            }
            counterIds.forEach((counterId) => {
                Analytics.yandexCall(counterId, ...args);
            });
        }
        else {
            this.callQueue.push({ args });
        }
    }
    static yandexCall(counter, ...args) {
        if (YandexMethodNames.includes(args[0])) {
            const methodName = args.shift();
            window.ym(counter, methodName, ...args);
        }
        else {
            window.ym(counter, Analytics.YandexDefaultMethodName, ...args);
        }
    }
}
Analytics.YandexDefaultMethodName = 'reachGoal';
export const analytics = new Analytics({
    yandex: YandexCounters,
});
//# sourceMappingURL=analytics.js.map